module.exports = __webpack_public_path__ + "img/chevron-right.85dec040.svg";